import { createContext, MutableRefObject, useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import {
  SEARCH_OPTION,
  SearchInstanceDto,
  SearchResultsDto,
  SearchResultsErrorsDto,
  SearchState,
  SearchStateInitialized,
  SelectedFacetAttributes,
} from '@app/components';
import { DateRange } from '@app/utils';
import { SetState } from '@app/constants';

export const SearchContext = createContext<SearchContextProps>(null!);

interface Results {
  searchResultsQuery: UseQueryResult<SearchResultsDto, SearchResultsErrorsDto>;
  pages: Array<SearchInstanceDto[] | undefined>;
  currentPage?: SearchInstanceDto[];
  totalRecords?: number;
}

export interface SearchContextProps {
  state: SearchStateInitialized;
  searchOption: SEARCH_OPTION;
  searchResults: Results;
  selectedFacets: SelectedFacetAttributes;
  selectedPublicationYear: DateRange;
  shouldRefocusRef: MutableRefObject<boolean>;
  instanceIdScrollTo: string | null;
  isPageFromBackButton: boolean;
  updateState: SetState<Partial<SearchState>>;
  setSelectedFacets: SetState<SelectedFacetAttributes>;
  setSelectedPublicationYear: SetState<DateRange>;
  setSearchOption: SetState<string>;
  setInstanceIdScrollTo: SetState<string | null>;
  setIsPageFromBackButton: SetState<boolean>;
}

export const useSearchContext = (): SearchContextProps =>
  useContext(SearchContext);
